import { JsonDiscriminatorValue, JsonObject, JsonProperty } from "ta-json";

import type { Nullable } from "../../../base-types";
import DataType from "../data-type";
import { PropertyDefinition } from "../property-definition";
import { StringContentType } from "../string-content-type";

/**
 *
 * String property definition.
 */
@JsonObject()
@JsonDiscriminatorValue(DataType.String)
export class StringPropertyDefinition extends PropertyDefinition {
    /**
     * Describes how the content should be displayed.
     */
    @JsonProperty("content_type")
    contentType: StringContentType;

    /**
     * A regular expression that must match the value of the property. If set to null the value is not checked.
     */
    @JsonProperty("validation_expression")
    validationExpression: Nullable<string>;

    /**
     * The name of the {@link IDataSource} to get possible values from.
     *
     * @remarks
     * Is null when there is no attached datasource.
     */
    dataSourceName: Nullable<string>;

    /**
     * The name of the {@link IOptionList} to get possible values from.
     *
     * @remarks
     * Is null when there is no attached option list.
     */
    get optionListName(): Nullable<string> {
        return this.dataSourceName;
    }
    set optionListName(value: Nullable<string>) {
        this.dataSourceName = value;
    }

    constructor(name: string, init?: Omit<Partial<StringPropertyDefinition>, "name">) {
        super(name, DataType.String);
        Object.assign(this, init);
    }
}
